export default function(primary: string) {
  const color = (primary.charAt(0) === '#') ? primary.substring(1, 7) : primary;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  const shouldUseDarkText = (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186);
  return shouldUseDarkText;
}
